import { create } from 'zustand';
import { env } from '@/utils/constants/env';
import { axiosInstance } from '@/utils/lib/axios';
import { ITasklistTask } from '@/api/tasklist';

interface FormState {
  taskCount: number;
  fetchTaskCount: () => Promise<void>;
  setTaskCount: (count: number) => void;
  taskGroupCount: number;
  fetchTaskGroupCount: () => Promise<void>;
  setTaskGroupCount: (count: number) => void;
  taskList: ITasklistTask[];
}

const useTaskState = create<FormState>(set => ({
  taskCount: 0,
  taskGroupCount: 0,
  taskList: [],
  setTaskCount: (count: number) => set({ taskCount: count }),
  setTaskGroupCount: (count: number) => set({ taskGroupCount: count }),

  fetchTaskCount: async () => {
    try {
      const url = new URL(env.apiTasklistBaseUrl + `/api/v1/tasklist/my-task?processKey=&page=${0}&limit=${1}`);
      const { data } = await axiosInstance.get(url.toString());
      set({ taskCount: data.data.totalElements ?? 0 }); // Assuming totalElements is the count
    } catch (error) {
      set({ taskCount: 0 }); // Reset to 0 on error
      console.error('Error fetching task count:', error);
    }
  },

  fetchTaskGroupCount: async () => {
    try {
      const url = new URL(env.apiTasklistBaseUrl + `/api/v1/tasklist/group-task?processKey=&page=${0}&limit=${1}`);
      const { data } = await axiosInstance.get(url.toString());
      set({ taskGroupCount: data.data.totalElements ?? 0 }); // Assuming totalElements is the count
    } catch (error) {
      set({ taskGroupCount: 0 }); // Reset to 0 on error
      console.error('Error fetching task group count:', error);
    }
  },
}));

export default useTaskState;
